export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-guide-dog-50cddac08ace7d076106b4be646e3c85.svg";